import React from 'react';
import { Link, useForm, usePage } from '@inertiajs/react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
    Card,
    CardContent,
    CardDescription,
    CardHeader,
    CardTitle,
} from '@/components/ui/card';

interface PageProps {
    flash?: {
        success?: string;
        error?: string;
    };
}

export default function PasswordResetRequestForm() {
    const { data, setData, post, processing, errors } = useForm({
        email_address: '',
    });

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        post('/passwords');
    };

    return (
        <Card>
            <CardHeader>
                <CardTitle className="text-2xl">Reset password</CardTitle>
                <CardDescription>
                    Enter your email address and we'll send you a link to reset your password
                </CardDescription>
            </CardHeader>
            <CardContent>
                <form onSubmit={handleSubmit}>
                    <div className="flex flex-col gap-6">
                        <div className="grid gap-2">
                            <Label htmlFor="email">Email</Label>
                            <Input
                                id="email"
                                type="email"
                                placeholder="m@example.com"
                                required
                                value={data.email_address}
                                onChange={(e) => setData('email_address', e.target.value)}
                                className={errors.email_address ? 'border-red-500' : ''}
                            />
                            {errors.email_address && (
                                <p className="text-sm text-destructive">{errors.email_address}</p>
                            )}
                        </div>

                        <Button type="submit" className="w-full" disabled={processing}>
                            {processing ? 'Sending...' : 'Send reset link'}
                        </Button>
                    </div>

                    <div className="mt-4 text-center text-sm">
                        Remember your password?{' '}
                        <Link href="/session/new" className="underline underline-offset-4">
                            Sign in
                        </Link>
                    </div>
                </form>
            </CardContent>
        </Card>
    );
}